// src/components/ExpenseForm.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './ExpenseForm.css';

Modal.setAppElement('#root');

const API_BASE = 'https://apiportal.mbsays.com/public/api';

const ExpenseForm = () => {
  const token = sessionStorage.getItem('authToken');
  const me = JSON.parse(sessionStorage.getItem('user') || '{}');
 

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
  };

  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [form, setForm] = useState({
    start_date: '',
    end_date: '',
    project_name: '',
    amount: '',
    description: '',
    status: 'pending'
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/expense-forms`, { headers })
      .then(res => {
        if (!res.ok) throw new Error('Veri alınamadı');
        return res.json();
      })
      .then(setExpenses)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const openModal = (expense = null) => {
    setSelectedExpense(expense);
    if (expense) {
      setForm({ ...expense });
    } else {
      setForm({
        start_date: '',
        end_date: '',
        project_name: '',
        amount: '',
        description: '',
        status: 'pending'
      });
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedExpense(null);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setSubmitting(true);

    const isEdit = selectedExpense !== null;

    const url = `${API_BASE}/expense-forms`;

    const payload = {
      ...form,
      id: isEdit ? selectedExpense.id : undefined,
      creation_date: new Date().toISOString().split('T')[0],
      amount: parseFloat(form.amount)
    };

    console.log("📤 GÖNDERİLEN:", payload);

    fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    })
      .then(async res => {
        const responseText = await res.text();
        console.log('📩 API CEVAP:', responseText);

        if (!res.ok) throw new Error('Kayıt veya güncelleme hatası');

        return JSON.parse(responseText);
      })
      .then(response => {
        const updated = response.form ?? response;
        if (isEdit) {
          setExpenses(prev =>
            prev.map(e => (e.id === selectedExpense.id ? updated : e))
          );
          alert('✅ Güncellendi');
        } else {
          setExpenses(prev => [updated, ...prev]);
          alert('✅ Eklendi');
        }
        closeModal();
      })
      .catch(err => {
        console.error('🚨 HATA:', err);
        alert('❌ HATA:\n' + err.message);
      })
      .finally(() => setSubmitting(false));
  };





  const markAsPaid = id => {
    const expense = expenses.find(e => e.id === id);
    if (!expense) return;

    const updated = { ...expense, status: 'paid' };

    fetch(`${API_BASE}/expense-forms/${id}/status`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({ status: 'paid' })
    })
      .then(res => {
        if (!res.ok) throw new Error('Ödeme güncelleme hatası');
        setExpenses(prev =>
          prev.map(e => (e.id === id ? updated : e))
        );
      })
      .catch(err => alert('❌ Durum güncelleme hatası: ' + err.message));
  };

  const deleteExpense = id => {
    if (!window.confirm("Silmek istediğine emin misin?")) return;

    fetch(`${API_BASE}/expense-forms/${id}`, {
      method: 'DELETE',
      headers
    })
      .then(res => {
        if (!res.ok) throw new Error("Silme başarısız");
        setExpenses(prev => prev.filter(e => e.id !== id));
        alert("🗑️ Başarıyla silindi");
      })
      .catch(err => alert("❌ Silme hatası: " + err.message));
  };

  const filtered = expenses.filter(e =>
    `${e.project_name} ${e.description}`.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div>Yükleniyor…</div>;
  if (error) return <div>Hata: {error}</div>;
  return (
    <div className="expense-form-container">
      <div className="search-bar">
        <input
          type="text"
          placeholder="Ara..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <table className="expense-table">
        <thead>
          <tr>
            <th>Oluşturma</th>
            <th>Tarih Aralığı</th>
            <th>Proje</th>
            <th>Tutar</th>
            <th>Açıklama</th>
            <th>Durum</th>
            <th>İşlem</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map(e => (
            <tr key={e.id}>
              <td>{e.creation_date}</td>
              <td>{e.start_date} — {e.end_date}</td>
              <td>{e.project_name}</td>
              <td>{e.amount}</td>
              <td>{e.description}</td>
              <td>
                {e.status === 'paid' ? (
                  <span className="status-paid">Ödendi</span>
                ) : (
                  <button className="mark-paid-button" onClick={() => markAsPaid(e.id)}>
                    Ödendi
                  </button>
                )}
              </td>
              <td>
                <button className="detail-button" onClick={() => openModal(e)}>Düzenle</button>
                <button className="delete-button" onClick={() => deleteExpense(e.id)}>Sil</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="add-button" onClick={() => openModal(null)}>
        Yeni Masraf Ekle
      </button>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Masraf Formu"
        className="modal"
        overlayClassName="modal-overlay"
      >
        <form onSubmit={handleSubmit}>
          <h2>{selectedExpense ? "Masraf Güncelle" : "Yeni Masraf Ekle"}</h2>
          <div className="modal-body">
            <div className="form-group">
              <label>Başlangıç Tarihi</label>
              <input
                type="date"
                value={form.start_date}
                onChange={e => setForm(f => ({ ...f, start_date: e.target.value }))}
                required
              />
            </div>
            <div className="form-group">
              <label>Bitiş Tarihi</label>
              <input
                type="date"
                value={form.end_date}
                onChange={e => setForm(f => ({ ...f, end_date: e.target.value }))}
                required
              />
            </div>
            <div className="form-group">
              <label>Proje Adı</label>
              <input
                type="text"
                value={form.project_name}
                onChange={e => setForm(f => ({ ...f, project_name: e.target.value }))}
                required
              />
            </div>
            <div className="form-group">
              <label>Harcama Tutarı</label>
              <input
                type="number"
                value={form.amount}
                onChange={e => setForm(f => ({ ...f, amount: e.target.value }))}
                required
              />
            </div>
            <div className="form-group">
              <label>Açıklama</label>
              <input
                type="text"
                value={form.description}
                onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
                required
              />
            </div>
            <div className="form-group">
              <label>Durum</label>
              <select
                value={form.status}
                onChange={e => setForm(f => ({ ...f, status: e.target.value }))}
              >
                <option value="pending">Bekliyor</option>
                <option value="paid">Ödendi</option>
              </select>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <button type="submit" className="submit-button" disabled={submitting}>
                {submitting ? 'Kaydediliyor…' : (selectedExpense ? 'Güncelle' : 'Kaydet')}
              </button>
              <button type="button" className="modal-close" onClick={closeModal}>x</button>
            </div>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default ExpenseForm;
